export const en = {
  // Common
  common: {
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    search: 'Search',
    searchGroups: 'Search groups...',
    searchVehicles: 'Search vehicles...',
    noGroupsFound: 'No groups found',
    noVehiclesFound: 'No vehicles found',
    searchDrivers: 'Search drivers...',
    noDriversFound: 'No drivers found',
    loading: 'Loading...',
    noData: 'No data found',
    today: 'Today',
    yesterday: 'Yesterday',
    thisWeek: 'This week',
    last7Days: 'Last 7 days',
    last30Days: 'Last 30 days',
    thisMonth: 'This month',
    customRange: 'Custom range',
    backToPresets: 'Back to presets',
    all: 'All',
    showing: 'Showing',
    to: 'to',
    of: 'of',
    entries: 'entries',
    page: 'Page',
    rows: 'rows',
    refresh: 'Refresh',
    selectAll: 'Select all',
    selectRow: 'Select row',
    pageNotFound: 'Oops! Page not found',
    returnToHome: 'Return to Home',
    kilometersShort: 'km',
    kilometersPerHourShort: 'km/h',
    litersShort: 'L',
    litersPer100KmShort: 'L/100km',
    exportFailed: 'Export failed',
    exportPdf: 'Export PDF',
    exportExcel: 'Export Excel',
    pdfExported: 'PDF Exported',
    excelExported: 'Excel Exported',
    exportSuccess: 'has been downloaded successfully.',
    dateRangeLabel: 'Date Range',
    generatedLabel: 'Generated',
    exportedBy: 'Exported by',
    totalsLabel: 'Totals',
    records: 'records',
    total: 'Total',
    hoursShort: 'h',
    minutesShort: 'm',
    secondsShort: 's',
    percentSymbol: '%',
    previous: 'Previous',
    next: 'Next',
    more: 'More',
    morePages: 'More pages',
    close: 'Close',
    toggleSidebar: 'Toggle Sidebar',
    previousSlide: 'Previous slide',
    nextSlide: 'Next slide',
    pagination: 'Pagination',
    breadcrumb: 'Breadcrumb',
  },

  // Navigation
  nav: {
    liveTracking: 'Live Tracking',
    history: 'History',
    vehicles: 'Vehicles',
    drivers: 'Drivers',
    zones: 'Zones',
    poi: 'POI',
    reports: 'Reports',
    notifications: 'Notifications',
    costs: 'Costs',
    editProfile: 'Edit profile',
    editProfileDesc: 'Update your name, contact details and password',
    profileUpdated: 'Profile updated',
    userSettings: 'User Settings',
    systemSettings: 'System Settings',
    signOut: 'Sign out',
    plan: 'Plan',
    userGuide: 'User guide (PDF)',
    language: 'Language',
    settings: 'Settings',
    groups: 'Groups',
    users: 'Users',
    activity: 'Activity Log',
    scheduledReports: 'Scheduled Reports',
  },

  // Auth
  auth: {
    welcomeBack: 'Welcome back',
    signInToContinue: 'Sign in to your account to continue',
    username: 'Username',
    email: 'Email',
    password: 'Password',
    signIn: 'Sign in',
    signingIn: 'Signing in...',
    fleetManagementSystem: 'Fleet Management System',
    demoCredentials: 'Demo: Use any email and password (min 6 chars)',
    invalidCredentials: 'Invalid credentials',
    enterCredentials: 'Please enter your credentials',
    passwordMinLength: 'Password must be at least 6 characters',
    sessionExpired: 'Your session has expired. Please sign in again.',
    appName: 'Global GPS',
    usernamePlaceholder: 'username',
    passwordPlaceholder: '••••••••',
    realTimeGpsTracking: 'Real-time GPS Tracking',
    monitorFleet247: 'Monitor your fleet 24/7',
    routeHistory: 'Route History',
    detailedVehicleData: 'Detailed vehicle data for every trip',
    enterpriseSecurity: 'Enterprise Security',
    encryptedDataRoleBasedAccess: 'Encrypted data with role-based access',
    pro: 'Pro',
    basic: 'Basic',
  },

  apiErrors: {
    invalid_preferences: 'Those notification settings could not be saved',
    missing_credentials: 'Username and password are required',
    invalid_credentials: 'Invalid username or password',
    missing_api_key: 'Please sign in to continue',
    invalid_token: 'Your session has expired. Please sign in again.',
    invalid_user: 'Your account could not be found',
    group_in_use: 'Group cannot be deleted while users or vehicles are assigned',
    username_exists: 'Username already exists',
    cannot_delete_self: 'You cannot delete your own account',
    not_found: 'Requested resource was not found',
    forbidden: 'You do not have permission to perform this action',
    missing_fields: 'Please complete all required fields',
    missing_id: 'Missing resource ID',
    method_not_allowed: 'Action is not allowed',
    invalid_group: 'Invalid group selected',
    invalid_device: 'That vehicle is not available to you',
    invalid_category: 'That category is not available',
    invalid_currency: 'Unsupported currency',
    category_in_use: 'The category is in use, or that code already exists',
    recurrence_in_use: 'This rule has already generated costs and cannot be deleted',
    cost_exists: 'This cost already exists. It was restored earlier.',
    cost_locked: 'This cost is closed. Only an administrator can unlock it.',
    invalid_rule: 'The repeat rule is incomplete or invalid',
    readonly_field: 'A read-only field cannot be changed',
    server_error: 'The server could not save the change. Nothing was saved.',
    request_failed: 'Request failed. Please try again.',
    invalid_request: 'Invalid request payload',
    invalid_response: 'Unexpected server response',
    range_too_long: 'The period can be at most 31 days.',
    invalid_file: 'The file type or size is not allowed',
    too_many_files: 'This cost already has the maximum of 10 files',
    upload_missing: 'The upload did not finish. Please try again.',
    s3_EntityTooLarge: 'The file is larger than 20 MB',
    s3_AccessDenied: 'The upload link expired. Please try again.',
    invalid_schedule: 'The schedule is incomplete or invalid',
    invalid_recipients: 'One or more email addresses are not valid',
    too_many_recipients: 'A schedule can have at most 10 recipients',
    invalid_timezone: 'Unknown time zone',
    schedule_limit: 'You have reached the maximum of 20 scheduled reports',
    too_many_requests: 'Please wait a minute before sending again',
  },

  // Live Tracking
  tracking: {
    vehicles: 'Vehicles',
    searchVehicles: 'Search vehicles...',
    visible: 'Visible',
    moving: 'Moving',
    idle: 'Idle',
    stopped: 'Stopped',
    offline: 'Offline',
    following: 'Following',
    speed: 'Speed',
    altitude: 'Altitude',
    satellites: 'Satellites',
    fuelLevel: 'Fuel Level',
    fuelUsed: 'Fuel Used',
    distance: 'Distance',
    engineTemp: 'Engine Temp',
    rpm: 'RPM',
    heading: 'Heading',
    fuel: 'Fuel',
    ignition: 'Ignition',
    on: 'On',
    off: 'Off',
    sensors: 'Sensors',
    history: 'History',
    settings: 'Settings',
    trackVehicle: 'Track this vehicle',
    stopTracking: 'Stop tracking',
    hideDetails: 'Hide details',
    showDetails: 'Show details',
    noCoordinates: 'No coordinates (hidden on map)',
    withoutCoordinates: 'Without coordinates',
    isolateStatusHint: 'Double-click to show only this status',
    overview: 'Overview',
    general: 'General',
    sentData: 'Sent Data',
    reports: 'Reports',
    lastUpdate: 'Last update',
    lastUpdateUnderMinute: '<1 min',
    lastUpdateMinutesUnit: 'min',
    latestInputs: 'Latest inputs',
    noSensorData: 'No sensor data',
    openReportsForVehicle: 'Open reports filtered for this vehicle.',
    openReports: 'Open Reports',
    followingGroup: 'Following group',
    make: 'Make',
    model: 'Model',
    year: 'Year',
    registration: 'Registration',
    deviceId: 'Device ID',
    noData: 'No data',
    viewHistory: 'View vehicle history',
    driver: 'Driver',
    goToHistory: 'Go to History',
    vehicleTable: 'Fleet table',
    vehicleTableDesc: 'Every vehicle with its latest telemetry, grouped by vehicle group.',
  },

  // Map
  map: {
    street: 'Street',
    muted: 'Muted',
    satellite: 'Satellite',
    dark: 'Dark',
    terrain: 'Terrain',
  },

  // History
  historyPage: {
    title: 'History & Reports',
    subtitle: 'View trip history, routes, and events',
    group: 'Group',
    allGroups: 'All Groups',
    vehicle: 'Vehicle',
    allVehicles: 'All Vehicles',
    period: 'Period',
    startTime: 'Start time',
    endTime: 'End time',
    invalidDateRange: 'End date and time must be after start date and time.',
    loadHistory: 'Load history',
    filtersChanged: 'Filters changed. Click “Load history” to refresh.',
    loadHistoryPrompt: 'Set filters and click “Load history” to view trips.',
    trips: 'Trips',
    distance: 'Distance',
    distanceTotal: 'Total Distance',
    fuelTotal: 'Total Fuel',
    avgSpeed: 'Avg Speed',
    events: 'Events',
    distanceByDay: 'Distance by Day',
    eventsByType: 'Events by Type',
    noEvents: 'No events in selected period',
    /** Keyed by the upstream `has_<type>` suffix; unknown types fall back to a humanized label. */
    routeEvents: {
      speeding: 'Vehicle speeding',
      street_speeding: 'Street limit',
      fuel_drain: 'Fuel drain',
      refuel: 'Refuel',
      parking_zone_changed: 'Parking zone change',
      go_zone_changed: 'Driving zone change',
      nogo_zone_changed: 'No-go zone change',
    },
    start: 'Start',
    end: 'End',
    duration: 'Duration',
    viewRoute: 'View Route',
    route: 'Route',
    maxSpeed: 'Max Speed',
    speedViolation: 'Speed Violation',
    harshBrake: 'Harsh Brake',
    harshAcceleration: 'Harsh Acceleration',
    idle: 'Idle',
    fuel: 'Fuel',
    fuelConsumed: 'Fuel Used',
    avgConsumption: 'Avg. Consumption',
    geofence: 'Geofence',
    routeStop: 'Stop',
    groupBy: 'Group by',
    groupByNone: 'No grouping',
    groupByDateVehicle: 'Date → Vehicle',
    groupByVehicleDate: 'Vehicle → Date',
    continued: 'continued',
    tooManyRoutes: 'routes loaded — rendering may be slow. Narrow the date range or select fewer vehicles.',
    statsToggle: 'Stats',
    showChart: 'Show chart',
    hideChart: 'Hide chart',
    exportMapPdf: 'Export map (PDF)',
    mapExportTitle: 'Route map',
    pointReadout: 'Values at marked point',
    pointTime: 'Time',
  },

  // Vehicles
  vehiclesPage: {
    title: 'Vehicles',
    subtitle: 'Manage your fleet vehicles and settings',
    addVehicle: 'Add Vehicle',
    addNewVehicle: 'Add New Vehicle',
    addNewVehicleDesc: 'Add a new vehicle to your fleet',
    vehicleName: 'Vehicle Name',
    plateNumber: 'Plate Number',
    deviceId: 'ID',
    selectGroup: 'Select a group',
    selectDriver: 'Select a driver',
    noDriver: 'No driver',
    driverAlreadyAssignedTitle: 'Driver is already assigned',
    driverAlreadyAssignedDesc: 'This driver is already assigned to the vehicles below. Continuing keeps those assignments and adds this one.',
    driverName: 'Driver name',
    totalVehicles: 'Total Vehicles',
    vehicleGroups: 'Vehicle Groups',
    allVehicles: 'All Vehicles',
    odometer: 'Odometer',
    tankCapacity: 'Tank Capacity (L)',
    make: 'Make',
    model: 'Model',
    year: 'Year',
    vehicleUpdated: 'Vehicle updated',
    maxSpeed: 'Max speed',
    trackSpeeding: 'Track vehicle max speed',
    trackStreetSpeeding: 'Track street speed limit',
    speedControl: 'Speed control',
    editSelected: 'Edit selected',
    selectedCount: '{count} selected',
    bulkEditTitle: 'Edit selected vehicles',
    bulkEditDesc: 'Only fields you enable below will be changed on the selected vehicles.',
    changeField: 'Change this field',
    clearSelection: 'Clear selection',
    bulkUpdated: '{count} vehicles updated',
    bulkUpdatedPartial: '{updated} updated, {failed} failed',
    allGroups: 'All groups',
    addService: 'Add service',
    vehicleSettings: 'Settings',
    vehicleActions: 'Vehicle actions',
  },

  // Drivers
  driversPage: {
    title: 'Drivers',
    subtitle: 'Manage drivers and vehicle assignments',
    addDriver: 'Add Driver',
    addNewDriver: 'Add New Driver',
    addNewDriverDesc: 'Add a new driver to your fleet',
    editDriver: 'Edit Driver',
    editDriverDesc: 'Update driver information',
    fullName: 'Full Name',
    phone: 'Phone',
    rfid: 'RFID',
    license: 'License',
    licenseNumber: 'License Number',
    licenseExpiry: 'License Expiry',
    address: 'Address',
    city: 'City',
    zip: 'ZIP',
    expires: 'Expires',
    assignedVehicle: 'Assigned Vehicle',
    assignVehicle: 'Assign Vehicle',
    selectVehicle: 'Select vehicle',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    onLeave: 'On Leave',
    unassigned: 'Unassigned',
    totalDrivers: 'Total Drivers',
    assigned: 'Assigned',
    allDrivers: 'All Drivers',
    saveChanges: 'Save Changes',
    driverAdded: 'Driver added successfully',
    driverUpdated: 'Driver updated successfully',
    driverDeleted: 'Driver deleted successfully',
    assignedVehicles: 'Assigned Vehicles',
    assignmentUpdated: 'Vehicle assignment updated',
    firstNamePlaceholder: 'John',
    lastNamePlaceholder: 'Smith',
  },

  // Zones
  zonesPage: {
    title: 'Zones',
    subtitle: 'Manage geofence zones for your fleet',
    drawZone: 'Draw Zone',
    undoPoint: 'Undo Point',
    points: 'points',
    totalZones: 'Total Zones',
    parking: 'Parking',
    noGo: 'No-Go',
    driving: 'Driving',
    custom: 'Custom',
    parkingZone: 'Parking Zone',
    noGoZone: 'No-Go Zone',
    drivingZone: 'Driving Zone',
    customZone: 'Custom Zone',
    zoneMap: 'Zone Map',
    zoneList: 'Zone List',
    createZone: 'Create Zone',
    createZoneDesc: 'Name and configure your new zone',
    editZone: 'Edit Zone',
    editZoneDesc: 'Update zone settings',
    zoneName: 'Zone Name',
    zoneType: 'Zone Type',
    clickToAdd: 'Click on the map to add points',
    noZones: 'No zones created yet. Click "Draw Zone" to create one.',
    zoneCreated: 'Zone created successfully',
    zoneUpdated: 'Zone updated successfully',
    zoneDeleted: 'Zone deleted successfully',
    needMorePoints: 'A zone needs at least 3 points',
    zoneNamePlaceholder: 'e.g., Main Parking Lot',
    shape: 'Shape',
    clearPoints: 'Clear points',
    pointLabel: 'Point',
    noPointsYet: 'Click the map to place the first point of the zone outline.',
    drawInstructions: 'Keep clicking the map to add points. Use Undo or Clear to correct.',
    zoneDescription: 'Description',
    zoneDescriptionPlaceholder: 'Optional notes about this zone',
  },

  // POI
  poiPage: {
    title: 'Points of Interest',
    subtitle: 'Manage locations and contacts',
    addPoi: 'Add POI',
    addPoiTitle: 'Add Point of Interest',
    addPoiDesc: 'Add a new location to your map',
    editPoiTitle: 'Edit Point of Interest',
    editPoiDesc: 'Update POI information',
    total: 'Total',
    partner: 'Partner',
    gasStation: 'Gas Station',
    warehouse: 'Warehouse',
    customer: 'Customer',
    serviceCenter: 'Service Center',
    other: 'Other',
    poiMap: 'POI Map',
    poiList: 'POI List',
    name: 'Name',
    type: 'Type',
    address: 'Address',
    latitude: 'Latitude',
    longitude: 'Longitude',
    clickToSelect: 'Click on map to select location',
    contactPerson: 'Contact Person',
    contactPhone: 'Contact Phone',
    contactEmail: 'Contact Email',
    description: 'Description',
    descriptionPlaceholder: 'Optional description of this location',
    notes: 'Notes',
    additionalNotes: 'Additional notes...',
    noPois: 'No POIs created yet. Click "Add POI" to create one.',
    poiAdded: 'POI added successfully',
    poiUpdated: 'POI updated successfully',
    poiDeleted: 'POI deleted successfully',
    namePlaceholder: 'e.g., Main Office',
    addressPlaceholder: '123 Main St, City, State',
    contactPersonPlaceholder: 'John Doe',
    contactPhonePlaceholder: '+1 555-0000',
    contactEmailPlaceholder: 'contact@company.com',
    location: 'Location',
    dragMarkerHint: 'Drag the marker or click the map to move it.',
  },

  // Reports
  reportsPage: {
    title: 'Reports',
    subtitle: 'Generate and export custom fleet reports',
    generateReport: 'Generate report',
    filtersChanged: 'Filters changed. Click “Generate report” to refresh.',
    reportType: 'Report Type',
    tripReport: 'Trip Report',
    fuelReport: 'Fuel Report',
    driverReport: 'Driver Report',
    vehicleUtilization: 'Vehicle Utilization',
    dateRange: 'Date Range',
    pickDateRange: 'Pick a date range',
    invalidDateRange: 'End date and time must be after start date and time.',
    tripReportDesc: 'Trip rows from route history API: plates, segments, distances, speeds, sample counts',
    fuelReportDesc: 'Refuellings per vehicle: how many, how much and when the last one was',
    driverReportDesc: 'Per-driver aggregates from route history (distance, time, speeds) and the vehicles driven',
    vehicleReportDesc: 'Per-vehicle aggregates from route history (distance, time, speeds) plus assigned group',
    startTime: 'Start Time',
    endTime: 'End Time',
    refuelCount: 'Refuellings',
    refuelledTotalL: 'Total Refuelled (L)',
    lastRefuel: 'Last Refuelling',
    drainCount: 'Fuel Drains',
    startLocation: 'Start Location',
    endLocation: 'End Location',
    distanceKm: 'Distance (km)',
    durationMin: 'Duration (min)',
    avgSpeedKmh: 'Avg Speed (km/h)',
    fuelL: 'Fuel Used (L)',
    avgConsumption: 'Avg. Consumption',
    routeNo: 'Route #',
    pointsCount: 'Sample points',
    totalDurationMinutes: 'Total Duration (min)',
    totalDurationHms: 'Total Duration (hh:mm:ss)',
    dateTime: 'Date/Time',
    location: 'Location',
    odometerKm: 'Odometer (km)',
    driver: 'Driver',
    totalTrips: 'Total Trips',
    totalDistanceKm: 'Total Distance (km)',
    group: 'Group',
    fuelLevelPercent: 'Fuel Level (%)',
    showingFirst: 'Showing first',
    ofRecords: 'records. Export to see all data.',
    allTime: 'All time',
    refuel: 'Refuel',
    consumption: 'Consumption',
    theft: 'Theft',
  },

  // Notifications
  notificationsPage: {
    settings: 'Notification settings',
    title: 'Notifications',
    unreadNotifications: 'unread notifications',
    allCaughtUp: 'All caught up!',
    markAllRead: 'Mark all as read',
    total: 'Total',
    alerts: 'Alerts',
    warnings: 'Warnings',
    unread: 'Unread',
    noNotifications: 'No notifications',
    youreAllCaughtUp: "You're all caught up!",
    eventLocation: 'Where it happened',
    locationUnavailable: 'No location was recorded for this notification.',
    view: 'View',
    followLive: 'Follow vehicle live',
    category: 'Event type',
    allCategories: 'All event types',
    source: 'Source',
    allSources: 'All',
    sourceVehicles: 'Vehicle events',
    sourceCosts: 'Cost reminders',
    vehicleEventsSection: 'Vehicle events',
    costRemindersSection: 'Cost reminders',
    loadMore: 'Load more',
    showingOf: '{shown} of {total}',
    noEventsInPeriod: 'No vehicle events in the selected period.',
    show: 'Show',
    filtersChanged: 'Filters changed. Click “Show” to refresh.',
  },

  // Live vehicle events (docs/Events.MD) and their toast preferences
  vehicleEvents: {
    types: {
      parking_enter: 'Vehicle entered a parking zone',
      parking_exit: 'Vehicle left a parking zone',
      go_zone_enter: 'Vehicle entered an allowed zone',
      go_zone_exit: 'Vehicle left an allowed zone',
      nogo_zone_enter: 'Vehicle entered a no-go zone',
      nogo_zone_exit: 'Vehicle left a no-go zone',
      driver_identified: 'Driver identified',
      driver_removed: 'Driver removed',
      driver_changed: 'Driver changed',
      started: 'Engine started',
      stopped: 'Engine stopped',
      speeding_start: 'Vehicle started speeding (vehicle limit)',
      speeding_end: 'Vehicle back under the vehicle limit',
      street_speeding_start: 'Vehicle over the road speed limit',
      street_speeding_end: 'Vehicle back under the road speed limit',
      refuel: 'Vehicle refuelled',
      missing_fuel: 'Fuel level drop',
      overheat: 'Engine overheating',
    },
    categories: {
      zone: 'Zones',
      driver: 'Driver',
      engine: 'Engine',
      speed: 'Speed',
      fuel: 'Fuel',
    },
    prefsTitle: 'Pop-up notifications',
    prefsHint: 'Choose which vehicle events pop up. Events that pop up are also kept in the notification list.',
    savedInstantly: 'Changes are saved as soon as you flip a switch.',
    toggleAll: 'All',
    muteSound: 'Mute sound',
    unmuteSound: 'Play a sound',
    newNotifications: 'new notifications',
    view: 'View',
    vehicle: 'Vehicle',
    zone: 'Zone',
    limit: 'limit',
  },

  // User Settings
  usersPage: {
    title: 'Users',
    subtitle: 'Manage client users and group assignments',
    addUser: 'Add User',
    editUser: 'Edit User',
    addUserDesc: 'Create a new user account',
    editUserDesc: 'Update user details and group access',
    fullName: 'Full Name',
    username: 'Username',
    password: 'Password',
    passwordOptional: 'Password (leave empty to keep current)',
    email: 'Email',
    phone: 'Phone',
    groups: 'Groups',
    noGroups: 'No groups available',
    selectedGroups: 'Selected groups',
    totalUsers: 'Total Users',
    allUsers: 'All Users',
    userAdded: 'User created successfully',
    userUpdated: 'User updated successfully',
    userDeleted: 'User deleted successfully',
    assignedGroups: 'Assigned groups',
    noAssignedGroups: 'No assigned groups',
    fullNamePlaceholder: 'John Smith',
    usernamePlaceholder: 'john.smith',
    emailPlaceholder: 'john@company.com',
    phonePlaceholder: '+1 555 0000',
  },

  // User Settings
  userSettingsPage: {
    title: 'User Settings',
    subtitle: 'Manage your account and preferences',
    profile: 'Profile',
    profileDesc: 'Your personal information',
    fullName: 'Full Name',
    email: 'Email',
    phone: 'Phone',
    role: 'Role',
    saveChanges: 'Save Changes',
    notifications: 'Notifications',
    notificationsDesc: 'Configure how you receive notifications',
    emailNotifications: 'Email Notifications',
    emailNotificationsDesc: 'Receive notifications via email',
    pushNotifications: 'Push Notifications',
    pushNotificationsDesc: 'Receive push notifications in browser',
    alertTypes: 'Alert Types',
    speedViolations: 'Speed Violations',
    fuelAlerts: 'Fuel Alerts',
    geofenceAlerts: 'Geofence Alerts',
    maintenanceReminders: 'Maintenance Reminders',
    preferences: 'Preferences',
    preferencesDesc: 'Customize your experience',
    language: 'Language',
    defaultCurrency: 'Default currency',
    defaultCurrencyDesc: 'New costs and recurring costs start in this currency. You can still change it on each cost.',
    defaultCurrencySaved: 'Default currency saved',
    defaultCurrencyUnavailable: 'Saving the default currency is not available yet.',
    timezone: 'Timezone',
    distanceUnit: 'Distance Unit',
    kilometers: 'Kilometers',
    miles: 'Miles',
    dateFormat: 'Date Format',
    savePreferences: 'Save Preferences',
    security: 'Security',
    securityDesc: 'Manage your account security',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    updatePassword: 'Update Password',
    settingsSaved: 'Settings saved successfully',
    phonePlaceholder: '+1 (555) 000-0000',
    pacificTime: 'Pacific Time (UTC-8)',
    easternTime: 'Eastern Time (UTC-5)',
    centralEuropeanTime: 'Central European (UTC+1)',
    dateFormatMdy: 'MM/DD/YYYY',
    dateFormatDmy: 'DD/MM/YYYY',
    dateFormatYmd: 'YYYY-MM-DD',
    utc: 'UTC',
  },

  // System Settings
  systemSettingsPage: {
    title: 'System Settings',
    subtitle: 'Configure global system preferences',
    mapSettings: 'Map Settings',
    mapSettingsDesc: 'Configure map display and behavior',
    refreshInterval: 'Refresh Interval (seconds)',
    showTrafficLayer: 'Show Traffic Layer',
    showTrafficDesc: 'Display real-time traffic data',
    satelliteView: 'Satellite View',
    satelliteViewDesc: 'Use satellite imagery',
    clusterMarkers: 'Cluster Markers',
    clusterMarkersDesc: 'Group nearby vehicles when zoomed out',
    alertThresholds: 'Alert Thresholds',
    alertThresholdsDesc: 'Set thresholds for automated alerts',
    speedLimitKmh: 'Speed Limit (km/h)',
    idleTimeoutMin: 'Idle Timeout (minutes)',
    lowFuelThreshold: 'Low Fuel Threshold (%)',
    geofenceAlerts: 'Geofence Alerts',
    geofenceAlertsDesc: 'Alert when vehicles leave designated areas',
    saveAlertSettings: 'Save Alert Settings',
    notificationDelivery: 'Notification Delivery',
    notificationDeliveryDesc: 'Configure how notifications are sent to users',
    emailServer: 'Email Server (SMTP)',
    smtpPort: 'SMTP Port',
    fromEmail: 'From Email',
    replyToEmail: 'Reply-to Email',
    saveNotificationSettings: 'Save Notification Settings',
    dataRetention: 'Data Retention',
    dataRetentionDesc: 'Configure data storage and cleanup policies',
    gpsHistoryRetention: 'GPS History Retention',
    tripHistoryRetention: 'Trip History Retention',
    alertHistoryRetention: 'Alert History Retention',
    backupFrequency: 'Backup Frequency',
    days: 'days',
    year: '1 year',
    years: '2 years',
    hourly: 'Hourly',
    daily: 'Daily',
    weekly: 'Weekly',
    saveRetentionSettings: 'Save Retention Settings',
    apiIntegrations: 'API & Integrations',
    apiIntegrationsDesc: 'Manage API keys and third-party integrations',
    apiKey: 'API Key',
    regenerate: 'Regenerate',
    apiKeyDesc: 'Use this key to integrate with external systems',
    webhookUrl: 'Webhook URL',
    webhookDesc: 'Events will be sent to this URL in real-time',
    saveApiSettings: 'Save API Settings',
    systemSettingsSaved: 'System settings saved successfully',
    emailServerPlaceholder: 'smtp.company.com',
    smtpPortPlaceholder: '587',
    fromEmailPlaceholder: 'alerts@company.com',
    replyToEmailPlaceholder: 'support@company.com',
    webhookUrlPlaceholder: 'https://api.yourcompany.com/webhooks/fleet',
  },

  // Groups
  groupsPage: {
    title: 'Vehicle Groups',
    subtitle: 'Organize your fleet into logical groups',
    addGroup: 'Add Group',
    addNewGroup: 'Add New Group',
    addNewGroupDesc: 'Create a new vehicle group for your fleet',
    groupName: 'Group Name',
    groupNamePlaceholder: 'Enter group name...',
    groupColor: 'Group Color',
    totalGroups: 'Total Groups',
    avgVehiclesPerGroup: 'Avg per Group',
    allGroups: 'All Groups',
    allGroupsDesc: 'Manage your vehicle groups and their settings',
    vehiclesAssigned: 'vehicles assigned',
    editGroup: 'Edit Group',
    editGroupDesc: 'Update group name and color',
    groupAdded: 'Group added',
    groupAddedDesc: 'Vehicle group has been created successfully.',
    groupUpdated: 'Group updated',
    groupUpdatedDesc: 'Vehicle group has been updated successfully.',
    groupDeleted: 'Group deleted',
    groupDeletedDesc: 'Vehicle group has been deleted.',
    cannotDelete: 'Cannot delete group',
    groupHasVehicles: 'This group still has vehicles assigned to it.',
  },

  // Costs
  costsPage: {
    title: 'Costs',
    subtitle: 'Vehicle costs, recurring schedules and upcoming reminders',
    tabOverview: 'Overview',
    tabCosts: 'Costs',
    tabRecurrences: 'Recurring',
    tabUpcoming: 'Upcoming',
    tabDeleted: 'Deleted',
    addCost: 'Add Cost',
    addCostDesc: 'Record a new cost for a vehicle',
    editCost: 'Edit Cost',
    editCostDesc: 'Update the cost record',
    saveChanges: 'Save Changes',
    vehicle: 'Vehicle',
    category: 'Category',
    date: 'Date',
    amount: 'Amount',
    currency: 'Currency',
    chartsCurrencyNote: 'Charts show only costs in {currency}.',
    costTitle: 'Title',
    description: 'Description',
    odometer: 'Odometer',
    planned: 'Planned',
    unplanned: 'Unplanned',
    status: 'Status',
    vendor: 'Vendor',
    invoiceNo: 'Invoice No.',
    documentUrl: 'Document link',
    statusPlanned: 'Planned',
    statusDone: 'Done',
    statusCancelled: 'Cancelled',
    statusInProgress: 'In progress',
    selectVehicle: 'Select vehicle',
    selectCategory: 'Select category',
    searchCategories: 'Search categories...',
    noCategoriesFound: 'No categories found',
    allCategories: 'All categories',
    allStatuses: 'All statuses',
    allVehicles: 'All vehicles',
    useCurrentOdometer: 'Use current reading',
    totalCost: 'Spent',
    plannedTotal: 'Planned',
    unplannedTotal: 'Unplanned',
    costCount: 'Records',
    forecastTotal: 'Forecast',
    markDone: 'Mark done',
    completeCost: 'Confirm cost',
    completeCostDesc: 'Enter the actual date, odometer and amount. The next due date is calculated from them.',
    costCompleted: 'Cost marked as done',
    anchorHint: 'When this was last done. The next due date and km are counted from here.',
    recurrenceInUse: 'This rule has already generated costs, so it cannot be deleted. Deactivate it instead to stop reminders.',
    deactivate: 'Deactivate',
    recurrenceDeactivated: 'Rule deactivated',
    recurrenceHistoryDesc: 'Who created and changed this rule, and the costs it generated',
    readOnlyNotice: 'You can view costs but not change them',
    startCost: 'Start cost',
    startCostDesc: 'Open a cost with just the vehicle. Add notes as the work goes on, then enter the price and close it.',
    closeCost: 'Close cost',
    closeCostDesc: 'Enter the final amount, date and odometer. Once closed, only an administrator can unlock it.',
    closeConfirmTitle: 'Close this cost?',
    closeConfirm: 'After closing, the cost is locked and only an administrator can unlock it.',
    costClosed: 'Cost closed',
    unlockCost: 'Unlock',
    unlockConfirmTitle: 'Unlock this cost?',
    unlockConfirm: 'The cost goes back to "In progress" and can be edited again. The unlock is recorded in its history.',
    costUnlocked: 'Cost unlocked',
    costLockedNotice: 'This cost is closed and locked. Only an administrator can unlock it.',
    progressNotesHint: 'What has been done so far — add to it as the work goes on',
    costPerKm: 'Cost per km',
    byCategory: 'By category',
    byVehicle: 'Top vehicles',
    overTime: 'Over time',
    noChartData: 'No costs in the selected period',
    addRecurrence: 'Add Rule',
    addRecurrenceDesc: 'Create a recurring cost schedule',
    editRecurrence: 'Edit Rule',
    editRecurrenceDesc: 'Update the recurring cost schedule',
    ruleType: 'Repeats',
    ruleInterval: 'Every period',
    ruleIntervalDesc: 'Annual registration, monthly lease',
    ruleMileage: 'Every distance',
    ruleMileageDesc: 'Oil service every 15,000 km',
    ruleIntervalAndMileage: 'Distance or period',
    ruleIntervalAndMileageDesc: 'Whichever comes first',
    ruleFixedDates: 'Fixed dates',
    ruleFixedDatesDesc: 'Summer and winter tyres',
    intervalValue: 'Every',
    intervalUnit: 'Unit',
    unitDay: 'Days',
    unitMonth: 'Months',
    unitYear: 'Years',
    mileageInterval: 'Every (km)',
    fixedDates: 'Dates',
    addFixedDate: 'Add date',
    anchorDate: 'Starting from',
    anchorOdometer: 'Starting odometer',
    estimatedAmount: 'Estimated amount',
    leadDays: 'Warn days ahead',
    leadKm: 'Warn km ahead',
    ruleActive: 'Active',
    rulePaused: 'Paused',
    nextDue: 'Next due',
    nextDueOdometer: 'Next due at',
    noRecurrences: 'No recurring costs yet',
    upcomingTitle: 'Upcoming costs',
    severityOverdue: 'Overdue',
    severityDueSoon: 'Due soon',
    severityUpcoming: 'Upcoming',
    daysLeft: 'days left',
    daysOverdue: 'days overdue',
    kmLeft: 'km left',
    kmOverdue: 'km over',
    logCost: 'Record cost',
    dismiss: 'Dismiss',
    noUpcoming: 'Nothing due',
    noUpcomingDesc: 'No costs are coming up in this period',
    history: 'Change history',
    historyDesc: 'Who created and changed this cost',
    noHistory: 'No history yet',
    deletedDesc: 'Costs deleted in the selected period, with who deleted them. The period applies to when they were deleted. The history button opens the cost\'s full history.',
    deletedAt: 'Deleted',
    deletedBy: 'Deleted by',
    deletedByOn: 'Deleted by {user} on {time}',
    deletedUnavailable: 'The list of deleted costs is not available on the server yet. The history of each cost is still kept.',
    deletedRangeTooLong: 'Choose a period of at most 366 days.',
    logCreate: 'created',
    logUpdate: 'updated',
    logDelete: 'deleted',
    logGenerate: 'generated automatically',
    logComplete: 'marked as done',
    systemUser: 'System',
    notSet: 'not set',
    tabDetails: 'Details',
    logTime: 'Time',
    logUser: 'User',
    logAction: 'Action',
    logChanges: 'Changes',
    logField: 'Field',
    logBefore: 'Before',
    logAfter: 'After',
    logNoChanges: 'No field changes were recorded for this entry',
    attachments: 'Files',
    attachmentsDesc: 'Receipts, invoices and photos for this cost',
    attachmentsQueuedDesc: 'Files are uploaded when the cost is saved',
    addFile: 'Add file',
    noAttachments: 'No files attached',
    attachmentLimit: 'A cost can have at most {count} files',
    uploading: 'Uploading…',
    uploadFailed: 'Upload failed',
    retry: 'Retry',
    remove: 'Remove',
    openAttachment: 'Open file',
    deleteAttachment: 'Delete file',
    deleteAttachmentConfirm: 'Delete "{name}"? This cannot be undone.',
    attachmentDeleted: 'File deleted',
    deleteCostTitle: 'Delete cost?',
    deleteCostConfirm: 'The cost moves to the Deleted tab, where it can be restored.',
    deleteCostWithFiles: 'The cost and its {count} attached files move to the Deleted tab. Restored within {days} days, it gets its files back. After that the files are removed for good.',
    logAttachmentAdd: 'added',
    logAttachmentDelete: 'removed',
    logClose: 'closed',
    logUnlock: 'unlocked',
    logRestore: 'restored',
    attachmentUnsupportedType: '"{name}" is not a supported file type (JPG, PNG, WebP, HEIC or PDF)',
    attachmentTooLarge: '"{name}" is larger than 20 MB',
    attachmentEmpty: '"{name}" is empty',
    attachmentsFailed: 'Cost saved, but {count} files could not be uploaded. Add them again from the cost.',
    attachmentCountLabel: '{count} attached files',
    createdBy: 'Created by',
    updatedBy: 'Last changed by',
    costAdded: 'Cost added successfully',
    costUpdated: 'Cost updated successfully',
    costDeleted: 'Cost deleted successfully',
    costRestored: 'Cost restored',
    restoreCost: 'Restore',
    restoreCostTitle: 'Restore this cost?',
    restoreCostConfirm: '"{title}" comes back as it was before it was deleted, with its history.',
    restoreFilesKept: 'Any attached files come back with it.',
    restoreFilesPurged: 'It was deleted more than {days} days ago, so any attached files have been removed for good and will not come back.',
    recurrenceAdded: 'Recurring cost added successfully',
    recurrenceUpdated: 'Recurring cost updated successfully',
    recurrenceDeleted: 'Recurring cost deleted successfully',
    noCosts: 'No costs recorded',
    reportTitle: 'Cost report',
    reportSubtitle: 'Vehicle costs for the selected period',
  },

  // Activity log
  activityPage: {
    title: 'Activity Log',
    subtitle: 'What each user opened, pulled and changed',
    user: 'User',
    allUsers: 'All users',
    eventType: 'Action',
    allEventTypes: 'All actions',
    resource: 'Area',
    allResources: 'All areas',
    searchPlaceholder: 'Search activity',
    eventLogin: 'Signed in',
    eventLogout: 'Signed out',
    eventPageView: 'Opened page',
    eventReportGenerate: 'Generated report',
    eventHistoryQuery: 'Ran history query',
    eventExportPdf: 'Exported PDF',
    eventExportExcel: 'Exported Excel',
    eventExportMapPdf: 'Exported map PDF',
    eventCreate: 'Created',
    eventUpdate: 'Changed',
    eventDelete: 'Deleted',
    resourceSession: 'Session',
    resourcePage: 'Page',
    resourceReport: 'Report',
    resourceHistory: 'History',
    resourceVehicle: 'Vehicle',
    resourceDriver: 'Driver',
    resourceZone: 'Zone',
    resourcePoi: 'POI',
    resourceGroup: 'Group',
    resourceUser: 'User',
    resourceCost: 'Cost',
    resourceCostCategory: 'Cost category',
    resourceCostRecurrence: 'Recurring cost',
    resourceScheduledReport: 'Scheduled report',
    summaryTitle: 'Users',
    summarySubtitle: 'Last login and activity in the selected period',
    lastLogin: 'Last login',
    lastActivity: 'Last activity',
    logins: 'Logins',
    events: 'Events',
    neverLoggedIn: 'Never signed in',
    time: 'Time',
    action: 'Action',
    area: 'Area',
    details: 'Details',
    path: 'Page',
    ipAddress: 'IP address',
    noActivity: 'No activity recorded',
    moreAvailable: 'Only the most recent rows are shown — narrow the date range to see older activity.',
    notAuthorized: 'Administrators only',
    notAuthorizedDesc: 'The activity log is available to account administrators.',
    reportTitle: 'Activity report',
    reportSubtitle: 'User activity for the selected period',
  },

  scheduledReportsPage: {
    title: 'Scheduled Reports',
    subtitle: 'Reports emailed to you automatically, on a schedule',
    newSchedule: 'New schedule',
    editSchedule: 'Edit schedule',
    empty: 'No scheduled reports yet',
    emptyDesc: 'Create one to have a report emailed every day, week or month.',
    unavailable: 'Scheduled reports are not available yet',
    unavailableDesc: 'The server does not support scheduled reports yet. Try again later.',
    name: 'Name',
    namePlaceholder: 'e.g. Yesterday\'s trips',
    reportType: 'Report',
    group: 'Group',
    vehicle: 'Vehicle',
    frequency: 'Frequency',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    sendTime: 'Send at',
    weekdays: 'Send on',
    weekdaysHint: 'No day selected means every day.',
    weekday: 'Day of the week',
    monthDay: 'Day of the month',
    timeZone: 'Time zone',
    searchTimeZone: 'Search time zones...',
    noTimeZones: 'No time zones found',
    language: 'Email language',
    formats: 'Attachments',
    formatPdf: 'PDF',
    formatXlsx: 'Excel',
    recipients: 'Recipients',
    recipientsPlaceholder: 'name@example.com',
    recipientsHint: 'Press Enter or comma to add an address. Up to 10.',
    removeRecipient: 'Remove {email}',
    active: 'Active',
    schedule: 'Schedule',
    nextRun: 'Next send',
    lastRun: 'Last send',
    never: 'Never',
    statusOk: 'Sent',
    statusFailed: 'Failed',
    statusRetrying: 'Retrying',
    periodDaily: 'Each email covers the previous day.',
    periodWeekly: 'Each email covers the previous week, Monday to Sunday.',
    periodMonthly: 'Each email covers the previous calendar month.',
    summaryDaily: 'Daily at {time}',
    summaryDailyDays: '{days} at {time}',
    summaryWeekly: 'Every {day} at {time}',
    summaryMonthly: 'Monthly on day {day} at {time}',
    nextSendPreview: 'Next send: {date}',
    sendNow: 'Send now',
    sendNowQueued: 'Report queued. It should arrive within a few minutes.',
    runHistory: 'Send history',
    noRuns: 'This schedule has not sent anything yet.',
    runTime: 'Time',
    runStatus: 'Status',
    runRows: 'Records',
    runRecipients: 'Recipients',
    runError: 'Error',
    runTrigger: 'Trigger',
    triggerSchedule: 'Scheduled',
    triggerManual: 'Manual',
    deleteTitle: 'Delete scheduled report?',
    deleteDescription: '"{name}" will stop sending and be permanently deleted.',
    created: 'Scheduled report created',
    updated: 'Scheduled report updated',
    deleted: 'Scheduled report deleted',
    activated: 'Schedule turned on',
    deactivated: 'Schedule turned off',
    scheduleThisReport: 'Schedule',
    nameRequired: 'Enter a name',
    formatRequired: 'Choose at least one attachment',
    recipientsRequired: 'Add at least one recipient',
    weekdayRequired: 'Choose a day of the week',
    invalidTime: 'Enter a time as HH:MM',
    actions: 'Actions',
  },

  scheduledReportEmail: {
    subject: '{report}: {period}',
    intro: 'Your scheduled report "{name}" is attached.',
    report: 'Report',
    period: 'Period',
    scope: 'Vehicles',
    records: 'Records',
    noData: 'No activity was recorded in this period.',
    footer: 'This email was sent automatically by {app}. To change or stop it, open Settings → Scheduled Reports.',
  },

  // Toasts
  toast: {
    welcomeBack: 'Welcome back!',
  },
};
